/**
 * @generated SignedSource<<a1dac8460ec764665a6965c089b2b05c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReadAllNotificationsMutationInput = {
  clientMutationId?: string | null;
};
export type NotificationsReadAllMutation$variables = {
  input: ReadAllNotificationsMutationInput;
};
export type NotificationsReadAllMutation$data = {
  readonly readAllNotifications: {
    readonly __typename: "ReadAllNotificationsError";
    readonly message: string;
  } | {
    readonly __typename: "ReadAllNotificationsSuccess";
    readonly notificationUnreadTotal: {
      readonly count: number;
      readonly id: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type NotificationsReadAllMutation = {
  response: NotificationsReadAllMutation$data;
  variables: NotificationsReadAllMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "readAllNotifications",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationUnreadTotal",
            "kind": "LinkedField",
            "name": "notificationUnreadTotal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "ReadAllNotificationsSuccess",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "ReadAllNotificationsError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsReadAllMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsReadAllMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7455d62b735f1f6a7f64e6d1bc36043d",
    "id": null,
    "metadata": {},
    "name": "NotificationsReadAllMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationsReadAllMutation(\n  $input: ReadAllNotificationsMutationInput!\n) {\n  readAllNotifications(input: $input) {\n    __typename\n    ... on ReadAllNotificationsSuccess {\n      notificationUnreadTotal {\n        id\n        count\n      }\n    }\n    ... on ReadAllNotificationsError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c09bff61f7662e9aad821d37577a623d";

export default node;
